<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/international-header.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/express-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            CTT Internacional Express
          </p>
          <p class="body-1 justify-text">
            Servicio global aéreo de entrega urgente de Export / Import para todo el mundo con
            salidas y entregas previstas durante los siguientes días laborables al de su admisión
            dependiendo del país de origen o destino.
          </p>
        </div>
      </div>
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/economy-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            CTT Internacional Economy
          </p>
          <p class="body-1 justify-text">
            Servicio terrestre de entrega urgente de Export / Import para Europa con salidas y
            entregas previstas durante los siguientes días laborables al de su admisión
            dependiendo del país de origen o destino.
          </p>
        </div>
      </div>
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ecommerce-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            CTT Internacional Ecommerce
          </p>
          <p class="body-1 justify-text">
            Servicio terrestre de entrega prevista durante los siguientes días laborables al de
            su admisión en los siguientes destinos: Francia, Alemania, Reino Unido, Bélgica, Holanda
            e Italia.
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/Footer'

export default {
  name: 'InternationalIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    isProductSelected(product) {
      return (
        product &&
        this.selectedItems.filter(element => element.desc_key === product.name).length !== 0
      )
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InternationalIntro')
  },
}
</script>
